<template>
  <footer class="footer">
    <p />
  </footer>
</template>

<script>
export default {
  name: "Footer"
};
</script>

<style lang="sass" scoped>

</style>
